import React, { Component } from "react";
import { Modal } from "semantic-ui-react";
import { FormattedMessage, injectIntl } from "react-intl";
import parse from "html-react-parser";

import { AuditButton } from "../../components/AuditButton/index";
import config from "config";

import "./styles.scss";

class HelpModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderBody = () =>{
    const { intl } = this.props;
    const email = config.helpDesk_Email;
    const body = intl.formatMessage({id:"components.layout.elements.MenuHeader.Menu.HelpDesk.FAQs"})
    return (
      <Modal.Description>
        {parse(body)}
        <a href={`mailto:${email}`}>{email}.</a>
      </Modal.Description>
    )
  }

  render() {
    const { onClose, isOpen } = this.props;
    return (
      <div>
        <Modal className="help-modal" open={isOpen}>
          <Modal.Header
            style={{
              fontFamily: "Noto Sans",
              height: "50px",
              padding: "14px 15px 16px 15px",
              backgroundColor: "#2E2E38",
              color: "#fff",
              fontSize: "16px"
            }}
          >
            <FormattedMessage
              className={"help-modal-header-title"}
              id="components.layout.elements.MenuHeader.Container.Menu.help"
            />
          </Modal.Header>
          <Modal.Content>            
            {this.renderBody()}
          </Modal.Content>
          <Modal.Actions className={"actions help-modal-actions"}>
            <AuditButton labelId={"common.ok"} onClick={onClose} />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default injectIntl(HelpModal);
